import { render, staticRenderFns } from "./collect-b2b.vue?vue&type=template&id=1202b354&scoped=true"
import script from "./collect-b2b.vue?vue&type=script&lang=js"
export * from "./collect-b2b.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1202b354",
  null
  
)

export default component.exports